module.exports = __webpack_public_path__ + "assets/img/school2.75383066.jpg";